angular.module('picmonic-common').factory('PresentationSourcing', [
  '$resource',
  function ($resource) {
    return $resource(
      '/api/v3/presentation-sourcing/:presentation_sourcing_id',
      { presentation_sourcing_id: '@presentation_sourcing_id' },
      {
        update: { method: 'PUT', isArray: false },
      }
    );
  },
]);
